export enum ProjectRolesEnum {
    PROJECT_MANAGER = 'PROJECT_MANAGER',
    MULTI_PROJECT_MANAGER = 'MULTI_PROJECT_MANAGER',
    PROGRAM_MANAGER = 'PROGRAM_MANAGER',
    SOLUTION_DESIGNER = 'SOLUTION_DESIGNER',
    MIGRATION_EXPERT = 'MIGRATION_EXPERT',
    TEST_MANAGER = 'TEST_MANAGER',
    CUTOVER_MANAGER = 'CUTOVER_MANAGER',
    RISK_MANAGER = 'RISK_MANAGER',
    BUSINESS_ANALYSTEN = 'BUSINESS_ANALYSTEN',
    BUSINESS_PROCESS_DESIGNER = 'BUSINESS_PROCESS_DESIGNER',
    CHANGE_MANAGER = 'CHANGE_MANAGER',
    AGILE_COACHES = 'AGILE_COACHES',
    SCRUM_MASTER = 'SCRUM_MASTER',
    PRODUCT_OWNER = 'PRODUCT_OWNER',
    CONSULTANT = 'CONSULTANT',
    PROJECT_MANAGEMENT_OFFICE = 'PROJECT_MANAGEMENT_OFFICE'
}